import RadioField from './RadioField'
import CheckField from './CheckField'

export const FIELDS = {
  radio: RadioField,
  check: CheckField,
}
